import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import linksDuck from 'components/links/duck'
import ErrorDefault from 'components/error/error-default'
import SearchNoResultBestSeller from './best-seller'
import SearchMessage from '../search-message'
import styles from './style.scss'

export const EMPTY_SEARCH_RESULT_REF_TYPE = 'zero_search_result'

const EmptySearchResult = ({ getLinks, message, query }) => {
  useEffect(() => {
    getLinks()
  }, [getLinks])

  return (
    <div>
      <style jsx>{styles}</style>
      {message || <SearchMessage countProducts={0} query={query} />}
      <ErrorDefault
        refType={EMPTY_SEARCH_RESULT_REF_TYPE}
        showDefaultError={false}
        showSearch={false}
      />
      <SearchNoResultBestSeller />
    </div>
  )
}

EmptySearchResult.defaultProps = {
  message: null,
  query: '',
}

EmptySearchResult.propTypes = {
  getLinks: PropTypes.func.isRequired,
  // replaces the default "No Results" message (in-page search, TECH-20)
  message: PropTypes.node,
  query: PropTypes.string,
}

export default connect(null, (dispatch) =>
  bindActionCreators({ getLinks: linksDuck.creators.get }, dispatch),
)(EmptySearchResult)
